export * from "./tabs"
export * as TabsStyles from "./tabs.styled"
